import { CampaignSelect, OnChangeHandler } from '../../formElements';
import { fetchCampaignsQuery } from './graphql';
import { ResourceComponentProps } from './types';
import { parseCampaignOption } from './utils';

export const ResourceCampaignSelect = ({
  onChange,
  messageMedium,
  ...props
}: ResourceComponentProps) => {
  const handleChange: OnChangeHandler = (_val, { option }) => {
    // Fixes WF-2231
    // TODO: Look further into why this is being triggered in the first place
    if (option) {
      onChange({
        ...option,
        label: `${option.label}`,
      });
    }
  };

  return (
    <CampaignSelect
      {...props}
      isMulti={false}
      data-formfieldtype="select"
      data-selectoptiontype="campaign"
      fetchAllItemsQuery={fetchCampaignsQuery}
      fetchAllItemsVariables={{
        campaignFilterInfo: { messageMedium: messageMedium ? [messageMedium] : null },
      }}
      parseOption={parseCampaignOption}
      onChange={handleChange}
      isFullWidth
    />
  );
};
